import React from 'react';

const requestMethods = [
  {
    slug: 'get',
    method: 'GET',
  },
  {
    slug: 'post',
    method: 'POST',
  },
  {
    slug: 'put',
    method: 'PUT',
  },
  {
    slug: 'patch',
    method: 'PATCH',
  },
  {
    slug: 'delete',
    method: 'DELETE',
  },
];

export default function UrlEditor({
  url,
  setUrl,
  reqMethod,
  setReqMethod,
  onInputSend,
}) {
  return (
    <>
      <form className='flex gap-2'>
        <select
          className='px-3 py-2 text-sm border rounded-lg border-gray-300 hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 bg-gray-50 transition-all duration-200'
          value={reqMethod}
          onChange={(e) => setReqMethod(e.target.value)}
        >
          {requestMethods.map((option) => (
            <option key={option.slug} value={option.method}>
              {option.method}
            </option>
          ))}
        </select>
        <input
          className='w-full px-3 py-2 text-sm border rounded-lg border-gray-300 hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 transition-all duration-200'
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button
          className='px-6 py-2 text-sm rounded-lg font-semibold text-white bg-gradient-to-r from-[#fdb814] to-[#e5a50f] hover:from-[#e5a50f] hover:to-[#d4940a] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30'
          type='button'
          onClick={(e) => onInputSend(e)}
        >
          Send
        </button>
      </form>
    </>
  );
}
